import { Image as ImageType, SampleItem } from '@types';
import { Url as UrlUtil } from '@utils';
import Http from './http';

const ImageUtil = {
  exists: (imageProps?: Partial<ImageType>): boolean => {
    if (!imageProps || !imageProps?.imageContent) {
      return false;
    }
    const requiredAttrs = ['mod', 'src', 'filename'];
    const { imageContent } = imageProps;
    return (
      requiredAttrs.find((item) => {
        return (
          imageContent[item] === null ||
          imageContent[item] === '' ||
          imageContent[item] === undefined
        );
      }) === undefined
    );
  },

  canLoadAllImages: (image: ImageType): boolean => {
    const hasMissingImage =
      [
        image.imageContent.mod,
        image.imageContent.previewMod,
        image.imageContent.previewSrc,
        image.imageContent.src,
      ].find((url: string, index: number) => {
        // see if any of the images have expires timestamps in the past:
        const expiresTimestamp = parseInt(UrlUtil.getParam('expires', url), 10);
        const currentTimestamp = Math.floor(new Date(Date.now()).getTime() / 1000);

        if (currentTimestamp > expiresTimestamp) {
          return true;
        }
      }) !== undefined;
    return !hasMissingImage;
  },

  formatSamples: (items: any[]): SampleItem[] => {
    return items.map((item) => {
      return {
        id: item.id,
        author: item.user.name || 'Unknown',
        urls: {
          full: item.urls.full,
          thumb: item.urls.thumb,
        },
      };
    });
  },

  buildStaticSamples: (): SampleItem[] => {
    const numberOfSamples = 9;
    const samples = [];
    for (let i = 1; i <= numberOfSamples; i++) {
      samples.push({
        id: i.toString(),
        urls: {
          thumb: `/static/img/samples/${i}_thumb.png`,
          full: `/static/img/samples/${i}.png`,
        },
      });
    }
    return samples;
  },

  getDownloadFilename: (path: string): string => {
    const extension = path.split('.').reverse()[0];
    return `wiremeshed.${extension}`;
  },
};

export default ImageUtil;
